import type { CourierTransaction } from 'common/api/api-types';
import type { CourierWithExtraInfo } from 'common/hooks/useMergeCourierExtraInfo';

import { useMemo } from 'react';
import { styled } from 'styled-components';

import { typographyCss } from '@creditornot/cb-ingredients';

import { useNumberFormatter } from 'common/hooks/useNumberFormatter';
import { calculateTaskRelated } from 'features/earnings/useAggregatedColumns';
import { getAmountToDisplay } from 'features/earnings/utils';

const Root = styled.div`
  ${typographyCss.Body3({ weight: 'semiBold' })};
`;
const TaskRelated: React.FC<{
  earnings?: CourierWithExtraInfo['_extra']['earnings'];
  transactions: Array<CourierTransaction['transactionType']>;
  title: string;
}> = ({ earnings, title, transactions }) => {
  const numberFormatter = useNumberFormatter();
  const currency = earnings?.aggregatedTransactions?.[0]?.currency;
  const amount = useMemo(
    () =>
      calculateTaskRelated({
        includedTransactionTypes: transactions,
        transactions: earnings?.aggregatedTransactions,
      }),
    [transactions, earnings?.aggregatedTransactions],
  );

  return (
    <Root title={title}>
      {getAmountToDisplay({ decimalFormat: numberFormatter?.decimalFormat, amount, currency })}
    </Root>
  );
};

export default TaskRelated;
